import { render } from "./TesteSwiper.vue?vue&type=template&id=2a1e4d67"
import script from "./TesteSwiper.vue?vue&type=script&lang=js"
export * from "./TesteSwiper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__